'use client';
import { Tabs, type TabsProps } from '@/ui-components/atoms/Layout/Tabs/Tabs';

export default function ClientTabsGroup({ items, navLayout, id }: TabsProps): React.JSX.Element {
    return <Tabs items={items} navLayout={navLayout} id={id} />;
}
